'use strict';

/**
 * List of objects with undefined location
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListLayout = require('modules/collection/views/layout/list');
var UndefinedStorageHeaderView = require('./undefined-storage-header');

var UndefinedStorageListLayout = ListLayout.extend({
    getHeaderViewClass: function () {
        return UndefinedStorageHeaderView;
    },

    onBeforeShow: function () {
        this.listenTo(this.model, 'change:sort', function (model, sort) {
            this.collection.sortByFields(sort);
        }.bind(this));
        ListLayout.prototype.onBeforeShow.apply(this, arguments);
    },
});

module.exports = UndefinedStorageListLayout;